
import { ResizerContainer } from '../styled/File.style'
import imgResizerSvg from './../../assets/svg/img-sizer.svg'

const ResizerIconContainer = () => {
  return (
    <ResizerContainer>
      <img src={imgResizerSvg} alt="resizer icon" />
    </ResizerContainer>
  )
}

export default ResizerIconContainer